import { r as registerInstance, h, e as Host } from './index-bfb2bce5.js';

const ttuiTypographyCss = ":host{color:var(--color-black);display:inline-block;font-size:1rem;font-weight:400}:host([ttui-title]){font-weight:700}:host([ttui-subtitle]){color:var(--color-secondary)}:host([ttui-small]){font-size:0.75rem}";

const Typography = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.ttuiTitle = false;
    this.ttuiSubtitle = false;
    this.ttuiSmall = false;
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
};
Typography.style = ttuiTypographyCss;

export { Typography as T };

//# sourceMappingURL=ttui-typography-440d8ab4.js.map